import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 9V7.25C6 3.84478 8.50314 1 12 1C15.4969 1 18 3.84478 18 7.25V9H18.5C19.8807 9 21 10.1193 21 11.5V19.5C21 20.8807 19.8807 22 18.5 22H5.5C4.11929 22 3 20.8807 3 19.5V11.5C3 10.1193 4.11929 9 5.5 9H6ZM7.5 7.25C7.5 4.58009 9.42172 2.5 12 2.5C14.5783 2.5 16.5 4.58009 16.5 7.25V9H7.5V7.25ZM4.5 11.5C4.5 10.9477 4.94772 10.5 5.5 10.5H18.5C19.0523 10.5 19.5 10.9477 19.5 11.5V19.5C19.5 20.0523 19.0523 20.5 18.5 20.5H5.5C4.94772 20.5 4.5 20.0523 4.5 19.5V11.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgLock;
